import React, { createContext, useContext, useState, useCallback } from "react";
import { CURRENCIES, setCurrency as applyCurrency } from "@/lib/api";

const CurrencyContext = createContext(null);
export const useCurrency = () => useContext(CurrencyContext);

const STORAGE_KEY = "wth_currency";

export const CurrencyProvider = ({ children }) => {
  const initial = (typeof localStorage !== "undefined" && localStorage.getItem(STORAGE_KEY)) || "GBP";
  applyCurrency(initial);
  const [code, setCode] = useState(initial);

  const setByCode = useCallback((c) => {
    applyCurrency(c);
    localStorage.setItem(STORAGE_KEY, c);
    setCode(c);
  }, []);

  const current = CURRENCIES.find((c) => c.code === code) || CURRENCIES[0];
  return (
    <CurrencyContext.Provider value={{ code, current, list: CURRENCIES, setByCode, convert: (a) => Math.round((a || 0) * current.rate) }}>
      {children}
    </CurrencyContext.Provider>
  );
};
